var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2758_112705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6659 3.88863C11.6659 3.12252 11.9702 2.38778 12.5119 1.84606C13.0537 1.30434 13.7884 1 14.5545 1C15.3206 1 16.0554 1.30434 16.5971 1.84606C17.1388 2.38778 17.4431 3.12252 17.4431 3.88863C19.1018 4.67293 20.5158 5.89381 21.5335 7.42041C22.5513 8.94701 23.1344 10.7218 23.2204 12.5545V16.8875C23.3291 17.7854 23.6471 18.6453 24.1488 19.3979C24.6506 20.1504 25.322 20.7747 26.109 21.2204H3C3.78706 20.7747 4.45848 20.1504 4.96021 19.3979C5.46193 18.6453 5.77994 17.7854 5.88863 16.8875V12.5545C5.97465 10.7218 6.55778 8.94701 7.57552 7.42041C8.59325 5.89381 10.0072 4.67293 11.6659 3.88863Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 21.2227V22.667C10.2188 23.8161 10.6753 24.9182 11.4878 25.7308C12.3004 26.5434 13.4025 26.9999 14.5517 26.9999C15.7009 26.9999 16.803 26.5434 17.6155 25.7308C18.4281 24.9182 18.8846 23.8161 18.8846 22.667V21.2227",
    stroke: "#8D8D8D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2758_112705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.8d373980b025426a3758e66ddffa9ff5.svg";
export { ForwardRef as ReactComponent };